import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import { loadAllAssessments } from "../../lib/api/assessment";
import { AssessmentHomeForm } from "../../components/assessment/AssessmentHomeForm";

const Home = () => {
  const navigate = useNavigate();

  const [asssessments, setAssessments] = useState();

  const requestLoadAllAssessments = useCallback(async () => {
    const { data } = await loadAllAssessments();
    setAssessments(data);
    //console.log(data);
  }, []);

  useEffect(() => {
    requestLoadAllAssessments();
  }, [requestLoadAllAssessments]);

  const handleDetail = (e) => {
    const id = e.target.value;
    navigate(`/assessments/${id}`);
  };

  return (
    <div>
      <Container fluid="md">
        <AssessmentHomeForm
          asssessments={asssessments}
          handleDetail={handleDetail}
        />
      </Container>
    </div>
  );
};

export default Home;
